export default class RichText {
  constructor(element) {
    this.el = element;
    this.tables = this.el.querySelectorAll("table");
    this.checkOverflow = this.checkOverflow.bind(this);
    this.init();
  }

  init() {
    let tablearray = [...this.tables];
    if (tablearray != null) {
      tablearray.forEach((table) => {
        let tablecontainer = document.createElement("div");
        tablecontainer.style.width = "100%";
        tablecontainer.style.overflowX = "scroll";
        tablecontainer.style.position = "relative";
        table.parentNode.insertBefore(tablecontainer, table);
        tablecontainer.appendChild(table);
        this.checkOverflow(table, tablecontainer);
      });
    }
  }
  checkOverflow(table, tablecontainer) {
    const tableWidth = table.scrollWidth;
    const containerWidth = tablecontainer.offsetWidth;
    if (tableWidth > containerWidth) {
      tablecontainer.insertAdjacentHTML("afterbegin", '<div class="md:hidden bg-white absolute w-28 h-28 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 rounded-full border-2 border-blue"><svg class="absolute w-20 h-20 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"><use xlink:href="/spritemap.svg#sprite-swipegesture"></use></svg></div>');
      tablecontainer.addEventListener("click", (e) => {
        tablecontainer.firstChild.classList.add("hidden");
      });
      tablecontainer.addEventListener("touchstart", (e) => {
        tablecontainer.firstChild.classList.add("hidden");
      });
    }
  }
}
